<div class="flex flex-row header pl-32 pt-16 justify-between">
    <div class="flex flex-row">
      <div>
        <img [routerLink]="['/', tenant]" alt="temenos-logo" (click)="onSwitchClick()" class="logo cursor-pointer logo-position mr-8" src="assets/images/temenos-white-logo.svg">
        <div class="pr-16 cloud-text fw-600 fs-14">{{ 'TOOLBAR.CLOUD_DASHBOARD' | transloco }}</div>
      </div>
      <div>
        <button type="button" class="tenant-trigger fw-500 ml-50" (click)="openTenantDialog()">
          <span class="tenant-trigger-text" [class.placeholder]="!getTenant()">
            {{ getTenant()?.tenantId || ('TENANT_LAYOUT.CHOOSE_TENANT' | transloco) }}
          </span>
          <span *ngIf="getTenant()?.origin === 'external'" class="external ml-6">2.0</span>
          <mat-icon class="icon-md ml-auto" svgIcon="keyboard_arrow_down"></mat-icon>
      </button>
      </div>
      <div *ngIf="regionResponse?.cloudProvider || regionResponse?.targetCloud" class="flex flex-row font-color ml-32 mt-10">
        <mat-icon class="icon-lg cursor-pointer mr-12" svgIcon="cloud"></mat-icon>
        <span class="mt-2">{{regionResponse?.cloudProvider || regionResponse?.targetCloud}}</span>
      </div>
      <div *ngIf="(regionResponse?.cloudProvider || regionResponse?.targetCloud) && (regionResponse?.regionPair || regionResponse?.temenosRegion || regionResponse?.primaryRegion || regionResponse?.primaryCloudRegion || regionResponse?.secondaryRegion || regionResponse?.secondaryCloudRegion)" class="border-left font-color ml-10 mt-10"></div>
      <div *ngIf="regionResponse?.regionPair || regionResponse?.temenosRegion || regionResponse?.primaryRegion || regionResponse?.primaryCloudRegion || regionResponse?.secondaryRegion || regionResponse?.secondaryCloudRegion" class="flex flex-row font-color mt-10 ml-6">
        <mat-icon class="icon-lg cursor-pointer mr-4" svgIcon="location_on"></mat-icon>
      </div>
      <div *ngIf="regionResponse?.regionPair || regionResponse?.temenosRegion" class="flex flex-row font-color mt-10 ml-6">
        <span class="mt-2">{{regionResponse?.regionPair ? regionResponse?.regionPair : regionResponse?.temenosRegion ? regionResponse?.temenosRegion : '-' }}</span>
      </div>
      <span *ngIf="regionResponse?.primaryRegion || regionResponse?.secondaryRegion || regionResponse?.primaryCloudRegion || regionResponse?.secondaryCloudRegion" class="mt-14 ml-6 flex flex-row font-color">
        <span class="fw-500 fs-14 color-region mr-4">({{'TENANT_LIST.Primary' | transloco }}</span>
        <span>{{regionResponse?.primaryRegion ? regionResponse?.primaryRegion : regionResponse?.primaryCloudRegion ? regionResponse?.primaryCloudRegion : '-'}}</span>
        <div *ngIf="hasSecondaryRegion">
          <span class="border-left-inner mt-6 ml-10 mr-6 color-region"></span>
          <span class="fw-500 fs-14 color-region mr-4">{{'TENANT_LIST.Secondary' | transloco }}</span>
          <span>{{regionResponse?.secondaryRegion ? regionResponse?.secondaryRegion : regionResponse?.secondaryCloudRegion ? regionResponse?.secondaryCloudRegion : '-'}}</span>
        </div>
        <span class="color-region">)</span>
      </span>
    </div>
    <mat-toolbar>
        <mat-toolbar-row class="flex flex-row mat-toolbar-row">
          <span class="example-spacer"></span>
          <div class="clock-widget flex flex-row items-center mr-8">
            <mat-icon class="clock-icon mr-6 flex" svgIcon="schedule"></mat-icon>
            <span class="clock-label">UTC</span>
            <span class="clock-time">{{ utcTime }}</span>
            <span class="clock-sep mr-10 flex">|</span>
            <span class="clock-label">{{ localTimezoneAbbr }}</span>
            <span class="clock-time">{{ localTime }}</span>
          </div>
          <div class="border-right ml-12"></div>
          <div class="flex flex-row justify-center items-center">
            <button (click)="openPlanModal()" *ngIf="hasMySandboxPermission"
                    [disabled]="!permissionsMap[Permission.UPGRADE_ENTERPRISE]"
                    class="rounded accent mr-14 hidden"
                    type="button">{{ 'TOOLBAR.UNLOCK_ENTERPRISE' | transloco }}</button>
                    <mat-icon (click)="onSwitchClick()" class="icon-lg cursor-pointer ml-16 mr-16" svgIcon="cameraswitch" matTooltipClass="form-tooltip left custom-tooltip" [matTooltip]="'ADD_VERSION.SWITCH_TO_DASHBOARD' | transloco"
                      matTooltipPosition="{{Constants.POSITION_LEFT}}">
                    </mat-icon>
                    @if (selectedTenantId){
                      <app-global-search [selectedTenantId]="selectedTenantId" (selectionChanged)="selectedTenant($event)" class="usermenu"></app-global-search>
                    }
            <mat-icon class="icon-lg cursor-pointer mr-10" svgIcon="help_outline" (click)="openAbout()" [attr.aria-label]="'TOOLBAR.ABOUT' | transloco" role="button" tabindex="0"></mat-icon>
            <div (click)="bookmarksClick()" class="border-right">
              <mat-icon class="icon-lg cursor-pointer ml-10 mr-20" svgIcon="bookmark_border"></mat-icon>
            </div>
            <!-- <div (click)="openNotifications()" class="border-right">
              <mat-icon class="icon-lg cursor-pointer ml-10 mr-20" svgIcon="notifications"></mat-icon>
            </div> -->
            <app-user-menu class="usermenu"></app-user-menu>
          </div>
        </mat-toolbar-row>
    </mat-toolbar>
</div>

